<template>
  <div>
    <Modal
        :without-template="true"
        :close="closeModals"
        :is-open="isModalActive"
    >
      <Login v-if="loginModal"/>
      <Login v-if="authToMessage" add-text="Авторизируйтесь, чтобы отправлять сообщения"/>
      <Login v-if="authToSignUp" add-text="Авторизируйтесь, чтобы записаться к мастеру"/>
      <NewPassword v-if="newPasswordModal"/>
      <Register_Main v-if="registerMainModal"/>
      <Register_Client v-if="registerClientModal"/>
      <Register_Master v-if="registerMasterModal"/>
      <Register_Confirm v-if="registerConfirmModal"/>
      <Register_Password v-if="registerPasswordModal"/>
      <Review v-if="reviewModal"/>
      <Recovery v-if="recoveryModal"/>
      <RecoveryVerify v-if="recoveryVerifyModal"/>
      <RecoveryPassword v-if="recoveryPasswordModal"/>

      <Rent v-if="rentModal"/>
      <Buy_Packages v-if="buyPackagesModal"/>
      <Buy_Packages_Offline v-if="buyPackagesOfflineModal"/>
      <Rent_Checkout v-if="rentCheckoutModal"/>
      <client-confirm v-if="clientCreateModal"/>
      <master-confirm v-if="masterCreateModal"/>

      <mobile-filters v-if="mobileFiltersModal"/>
      <HistoryModal v-if="cabinetMasterClientHistory"/>
      <NewClientModal v-if="newClientModal"/>
      <CabinetMasterSettingsPricesEditModal v-if="masterCabinetSettingsEditModal"/>

      <DetailsOfBooking v-if="masterCabinetCalendarDetailsOfBooking"/>
      <DetailsOfRecording v-if="masterCabinetCalendarDetailsOfRecording"/>
      <EditRecord v-if="masterCabinetCalendarEditRecord"/>
      <NewBooking v-if="masterCabinetCalendarNewBooking"/>
      <NewRecord v-if="masterCabinetCalendarNewRecord"/>
    </Modal>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import Review from '@/pages/Review/Review'
import Recovery from '@/pages/Auth/Recovery/Index'
import RecoveryVerify from '@/pages/Auth/Recovery/Verify'
import RecoveryPassword from '@/pages/Auth/Recovery/Password'
import NewPassword from '@/pages/Auth/Login/NewPassword'
import Register_Confirm from '@/pages/Auth/Register/Register_Confirm'
import Register_Master from '@/pages/Auth/Register/Register_Master'
import Register_Client from '@/pages/Auth/Register/Register_Client'
import Register_Main from '@/pages/Auth/Register/Register_Main'
import Register_Password from '@/pages/Auth/Register/Register_Password'
import Login from '@/pages/Auth/Login/Login'
import Modal from '@/components/functional/Modal'
import Rent from '@/components/Modals/ModalsLayout/Rent'
import Buy_Packages from '@/components/Modals/ModalsLayout/Buy_Packages'
import Buy_Packages_Offline from '@/components/Modals/ModalsLayout/Buy_Packages_Offline'
import Rent_Checkout from '@/components/Modals/ModalsLayout/Rent_Checkout'
import ClientConfirm from "@/pages/Cabinet/Admin/Client/Confirm"
import MasterConfirm from "@/pages/Cabinet/Admin/Master/Confirm"
import MobileFilters from '@/components/Modals/ModalsLayout/MobileFilters'
import HistoryModal from '@/pages/Cabinet/Master/Clients/HistoryModal'
import NewClientModal from '@/pages/Cabinet/Master/Clients/NewClientModal'
import CabinetMasterSettingsPricesEditModal from '@/pages/Cabinet/Master/Settings/CabinetMasterSettingsPricesEditModal'
import DetailsOfBooking from '@/pages/Cabinet/Master/CalendarModals/DetailsOfBooking'
import DetailsOfRecording from '@/pages/Cabinet/Master/CalendarModals/DetailsOfRecording'
import EditRecord from '@/pages/Cabinet/Master/CalendarModals/EditRecord'
import NewBooking from '@/pages/Cabinet/Master/CalendarModals/NewBooking'
import NewRecord from '@/pages/Cabinet/Master/CalendarModals/NewRecord'

export default {
  name: 'Modals',
  components: {
    Buy_Packages_Offline,
    NewRecord,
    NewBooking,
    EditRecord,
    DetailsOfRecording,
    DetailsOfBooking,
    CabinetMasterSettingsPricesEditModal,
    NewClientModal,
    HistoryModal,
    MobileFilters,
    Rent_Checkout,
    Buy_Packages,
    Rent,
    ClientConfirm,
    MasterConfirm,
    Review,
    Recovery,
    RecoveryVerify,
    RecoveryPassword,
    NewPassword,
    Register_Confirm,
    Register_Master,
    Register_Client,
    Register_Main,
    Login,
    Modal,
    Register_Password,
  },
  computed: {
    ...mapGetters([
      'isModalActive',
      'loginModal',
      'reviewModal',
      'newPasswordModal',
      'authToMessage',
      'authToSignUp',
      'restoreModal',
      'registerMainModal',
      'registerClientModal',
      'registerMasterModal',
      'registerConfirmModal',
      'registerPasswordModal',
      'recoveryModal',
      'recoveryVerifyModal',
      'recoveryPasswordModal',
      'rentModal',
      'buyPackagesModal',
      'buyPackagesOfflineModal',
      'rentCheckoutModal',
      'clientCreateModal',
      'masterCreateModal',
      'mobileFiltersModal',
      'cabinetMasterClientHistory',
      'newClientModal',
      'masterCabinetSettingsEditModal',
      'masterCabinetCalendarDetailsOfBooking',
      'masterCabinetCalendarDetailsOfRecording',
      'masterCabinetCalendarEditRecord',
      'masterCabinetCalendarNewBooking',
      'masterCabinetCalendarNewRecord'
    ]),
  },
  methods: {
    ...mapMutations(['closeModals', 'openModal']),
  },
}
</script>

<style scoped>

</style>
